import { BabylonState } from "../../state";

import { reloadStaleGrid } from "./reloadGrid";
import { reloadStalePaths } from "./reloadPaths";
import { reloadStalePositions } from "./reloadPositions";
import {
  reloadStaleVectorFieldCaches,
  reloadStaleVectorFieldMeshes,
} from "./reloadVectorFields";

/**
 * Schedules data loads for any components whose data has gone stale.
 */
export function reloadStaleComponents(state: BabylonState) {
  reloadStaleGrid(state);
  reloadStalePositions(state);
  reloadStalePaths(state);
  reloadStaleVectorFieldCaches(state);
  reloadStaleVectorFieldMeshes(state);
}
